import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-chip',
  styleUrls: ['dda-chip.css'],
  shadow: false,
})
export class DdaChip {
  @Prop() bg_color: string = 'success';
  @Prop() rounded?: string = '';
  @Prop() chip_text: string;
  @Prop() chip_icon: string;
  @Prop() chip_icon_family: string;
  @Prop() chip_icon_size: string;
  @Prop() show_close_icon: boolean = false;
  @Prop() size?: string; // e.g., 'sm', 'md', 'lg'
  @Prop() custom_class?: string;
  @Prop() component_mode?: string;  
  @Prop() clickHandler?: (event: MouseEvent) => void;

  @Prop() image_chip_label: string;
  @Prop() image_chip_icon: string;
  @Prop() image_chip_icon_family: string;
  @Prop() image_chip_icon_size?: string;

  render() {
    const label = this.image_chip_label || this.chip_text || 'Chip item';

    return (
      <Host>
        <div
          class={`dda-chip dda-chip-${this.bg_color} dda-chip-${this.size} dda-rounded-${this.rounded} ${this.custom_class} ${this.component_mode}`}
          aria-label={label}
        >
          {this.chip_icon ? (
            <i class={`chip-icon-size-${this.chip_icon_size} ${this.chip_icon_family}`}>
              {this.chip_icon}
            </i>
          ) : null}
          {this.image_chip_icon ? (
            <i class={`chip-icon-size-${this.image_chip_icon_size} ${this.image_chip_icon_family}`}>
              {this.image_chip_icon}
            </i>
          ) : null}
          <span>{this.chip_text}</span>
          {this.image_chip_label ? <span>{this.image_chip_label}</span> : null}
          {this.show_close_icon && (
            <span class="chip-close" onClick={this.clickHandler}>
              <i class="material-icons material-symbols-outlined" aria-hidden="true">close</i>
            </span>
          )}
        </div>
      </Host>
    );
  }
}

